import type { TenantView } from '@teachpartner/contracts';
import { UpdateNoticeNote } from '../../components/update-notice';
import { Unknown, VersionStatusBadge } from '../../components/version';

function Value({ value, missing }: { value: string | null; missing: string }) {
  return value ? <>{value}</> : <Unknown label={missing} />;
}

/** Versions the school last reported on the health poll (kept when later polls fail). */
export function VersionSection({ tenant }: { tenant: TenantView }) {
  const v = tenant.versions;
  return (
    <section aria-label="Versions">
      <h2>
        Versions <VersionStatusBadge status={tenant.versionStatus} latest={tenant.latestRelease} />{' '}
        <UpdateNoticeNote notice={tenant.updateNotice} />
      </h2>
      <dl className="facts">
        <dt>Release</dt>
        <dd>
          <Value value={v?.release ?? null} missing="Not reported" />
        </dd>
        <dt>tenant-api</dt>
        <dd>
          <Value value={v?.tenantApi ?? null} missing="Not reported" />
        </dd>
        <dt>Keycloak</dt>
        <dd>
          <Value value={v?.keycloak ?? null} missing="Not reported" />
        </dd>
        <dt>Latest release</dt>
        <dd>
          <Value value={tenant.latestRelease} missing="Not configured (TP_LATEST_RELEASE)" />
        </dd>
        <dt>Last reported</dt>
        <dd>{v ? v.reportedAt : 'never'}</dd>
      </dl>
      <p className="muted">Updates are manual in Phase 1: run the update on the school server.</p>
    </section>
  );
}
